import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

// import { BASE_STYLES } from '../utils/constants';

export const CardContainer = superstyled({
  name: 'VeloQA',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    // ...BASE_STYLES,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    borderRadius: theme.shape.rounded.xl,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: '50rem',
    containerType: 'inline-size', // Enable container queries for children
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2)
    }
  })
});

export const HeaderSection = superstyled({
  name: 'VeloQA',
  slot: 'HeaderSection',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  })
});

export const LogoContainer = superstyled({
  name: 'VeloQA',
  slot: 'LogoContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  })
});

export const ZenBusinessLogo = superstyled({
  name: 'VeloQA',
  slot: 'ZenBusinessLogo',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily
  })
});

export const VeloText = superstyled({
  name: 'VeloQA',
  slot: 'VeloText',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const TitleContainer = superstyled({
  name: 'VeloQA',
  slot: 'TitleContainer',
  tag: Box,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column'
  })
});

export const PromptsContainer = superstyled({
  name: 'VeloQA',
  slot: 'PromptsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(1.5),
    alignSelf: 'center',
    justifyItems: 'center',
    // Container query - responds to CardContainer width, not viewport
    '@container (max-width: 30rem)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  })
});

export const PromptChip = superstyled({
  name: 'VeloQA',
  slot: 'PromptChip',
  tag: Button,
  styles: ({ theme }) => ({
    width: 'fit-content',
    fontWeight: 400,
    border: '1px solid transparent',
    backgroundColor: theme.palette.background.grey.dark,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.background.grey.darker
    }
  })
});

export const InputContainer = superstyled({
  name: 'VeloQA',
  slot: 'InputContainer',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    margin: '0 auto',
    zIndex: 10,
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(0.5)
    }
  })
});

export const AnswerArea = superstyled({
  name: 'VeloQA',
  slot: 'AnswerArea',
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    minHeight: '6.25rem',
    borderRadius: theme.shape.rounded.md,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5),
      minHeight: '5rem'
    }
  })
});

export const ResponseContainer = superstyled({
  name: 'VeloQA',
  slot: 'ResponseContainer',
  tag: Box,
  styles: ({ theme, isExpanded }) => ({
    width: '100%',
    maxHeight: isExpanded ? 'none' : '15rem',
    overflow: 'hidden',
    position: 'relative',
    transition: 'max-height 0.3s ease-in-out',
    ...(!isExpanded && {
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '5rem',
        background: `linear-gradient(to bottom, transparent, ${theme.palette.background.paper})`,
        pointerEvents: 'none'
      }
    })
  })
});

export const ExpandButton = superstyled({
  name: 'VeloQA',
  slot: 'ExpandButton',
  tag: Button,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 2),
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  })
});

export const CollapseButton = superstyled({
  name: 'VeloQA',
  slot: 'CollapseButton',
  tag: Button,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: '14px',
    padding: theme.spacing(1, 2),
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  })
});

export const CTAFooter = superstyled({
  name: 'VeloQA',
  slot: 'CTAFooter',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(1.5)
    }
  })
});
